<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Accessories</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (emergencyHeaterSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Emergency Heater:</label>
              <select class="halfWidthInputField" #emergencyHeaterInput
                [class.invalidConfigurationSelection]="isInvalidSelection(emergencyHeaterSelection.Name)"
                (change)="selectionChanged(emergencyHeaterSelection, emergencyHeaterInput.value)"
                [value]="emergencyHeaterSelection.Value.toString()">
                @for (allowable of emergencyHeaterSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="emergencyHeaterSelection.Value && emergencyHeaterSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (thermostatSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Thermostat:</label>
              <select class="halfWidthInputField" #thermostatInput
                [class.invalidConfigurationSelection]="isInvalidSelection(thermostatSelection.Name)"
                (change)="selectionChanged(thermostatSelection, thermostatInput.value)"
                [value]="thermostatSelection.Value.toString()">
                @for (allowable of thermostatSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="thermostatSelection.Value && thermostatSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (wallPlateSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(wallPlateSelection.Name)"
              for="wallPlateInput" class="halfWidthInputLabel">Wall Plate:</label>
              <input type="checkbox" class="checkboxInput" id="wallPlateInput"
                #wallPlateInput [checked]="'true' === wallPlateSelection.Value"
                (change)="selectionChanged(wallPlateSelection, wallPlateInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (smartTankSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">iGate 2 Smart Tank:</label>
              <select class="halfWidthInputField" #smartTankInput
                [class.invalidConfigurationSelection]="isInvalidSelection(smartTankSelection.Name)"
                (change)="selectionChanged(smartTankSelection, smartTankInput.value)"
                [value]="smartTankSelection.Value.toString()">
                @for (allowable of smartTankSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="smartTankSelection.Value && smartTankSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (outdoorTemperatureSensorSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(outdoorTemperatureSensorSelection.Name)"
              for="outdoorTempSensorInput" class="halfWidthInputLabel">Outdoor Temperature Sensor:</label>
              <input type="checkbox" class="checkboxInput" id="outdoorTempSensorInput"
                #outdoorTempSensorInput [checked]="'true' === outdoorTemperatureSensorSelection.Value"
                (change)="selectionChanged(outdoorTemperatureSensorSelection, outdoorTempSensorInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (antiScaldValveSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(antiScaldValveSelection.Name)"
              for="antiScaldValveInput" class="halfWidthInputLabel">Anti-Scald Valve:</label>
              <input type="checkbox" class="checkboxInput" id="antiScaldValveInput"
                #antiScaldValveInput [checked]="'true' === antiScaldValveSelection.Value"
                (change)="selectionChanged(antiScaldValveSelection, antiScaldValveInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (compressorSoftStartKitSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(compressorSoftStartKitSelection.Name)"
              for="compressorSoftStartKitInput" class="halfWidthInputLabel">Compressor Soft Start Kit:</label>
              <input type="checkbox" class="checkboxInput" id="compressorSoftStartKitInput"
                #compressorSoftStartKitInput [checked]="'true' === compressorSoftStartKitSelection.Value"
                (change)="selectionChanged(compressorSoftStartKitSelection, compressorSoftStartKitInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (unitPadSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(unitPadSelection.Name)"
              for="unitPadInput" class="halfWidthInputLabel">Unit Pad:</label>
              <input type="checkbox" class="checkboxInput" id="unitPadInput"
                #unitPadInput [checked]="'true' === unitPadSelection.Value"
                (change)="selectionChanged(unitPadSelection, unitPadInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (packagedUnitStandSelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(packagedUnitStandSelection.Name)"
              for="packagedUnitStandInput" class="halfWidthInputLabel">Packaged Unit Stand:</label>
              <input type="checkbox" class="checkboxInput" id="packagedUnitStandInput"
                #packagedUnitStandInput [checked]="'true' === packagedUnitStandSelection.Value"
                (change)="selectionChanged(packagedUnitStandSelection, packagedUnitStandInput.checked.toString())">
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (extendedWarrantySelection) {
            <span class="fullWidthConfigurationInput">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(extendedWarrantySelection.Name)"
              for="extendedWarrantyInput" class="halfWidthInputLabel">Extended Warranty:</label>
              <input type="checkbox" class="checkboxInput" id="extendedWarrantyInput"
                #extendedWarrantyInput [checked]="'true' === extendedWarrantySelection.Value"
                (change)="selectionChanged(extendedWarrantySelection, extendedWarrantyInput.checked.toString())">
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
